import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const TabContext = createContext(undefined);
// Create a provider for components to consume and subscribe to changes
export function TabStateProvider({ children }) {
    const [state, setState] = useState('');
    return _jsx(TabContext.Provider, { value: [state, setState], children: children });
}
export function useTabSet() {
    return useContext(TabContext);
}
